<mat-toolbar>
  <h4 mat-dialog-title style="width: 100%"></h4>
  <span class="fill-remaining-space"></span>
  <button class="btn-dialog-close" mat-raised-button (click)="onClose()" tabindex="-1">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <fieldset>
    <legend>Usuarios para agregar al grupo: {{ group.name }}</legend>

    <ng-container *ngIf="loadingUser === true">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>

    <app-user-list *ngIf="availableUsers && loadingUser === false" [currentModule]="'groups'" [users]="availableUsers" [externalAction]="'add-user-group'" (emitSelectedUsr)="processUser($event)"></app-user-list>

  </fieldset>
</mat-dialog-content>
<hr>
<mat-dialog-actions align="end">
  <button class="btn" mat-stroked-button (click)="onClose()">Cerrar Ventana</button>
</mat-dialog-actions>


